module.exports = __webpack_public_path__ + "img/oper-icon4.58ed859e.png";